import { createClient } from '@base44/sdk';
import { appParams } from '@/lib/app-params';

const { appId, serverUrl, token, functionsVersion } = appParams;

// Create a client with authentication required.
// Guarded: if the SDK throws at module-init (bad params, SDK bug), we must NOT
// let it crash the whole bundle before React mounts — that would blank the page.
let client;
try {
  client = createClient({
    appId,
    serverUrl,
    token,
    functionsVersion,
    requiresAuth: false,
  });
} catch (err) {
  // Surface for debugging but keep the app booting; the error boundary / boot
  // guard will show a friendly fallback instead of a white screen.
  console.error('[base44Client] Failed to initialize SDK client:', err);
  client = null;
}

export const base44 = client;